import ReactECharts from "echarts-for-react";

interface GaugeChartProps {
  value: number;
  label: string;
  color?: string;
  alertThreshold?: number;
  height?: number;
}

export function GaugeChart({
  value,
  label,
  color = "#00553E",
  alertThreshold,
  height = 200,
}: GaugeChartProps) {
  const activeColor =
    alertThreshold !== undefined && value >= alertThreshold
      ? "#ef4444"
      : color;

  const option = {
    series: [
      {
        type: "gauge",
        radius: "88%",
        startAngle: 200,
        endAngle: -20,
        min: 0,
        max: 100,
        splitNumber: 5,
        axisLine: {
          lineStyle: {
            width: 12,
            color: [
              [value / 100, activeColor],
              [1, "#e2e8f0"],
            ],
          },
        },
        pointer: { show: false },
        axisTick: { show: false },
        splitLine: { show: false },
        axisLabel: { show: false },
        detail: {
          valueAnimation: true,
          formatter: "{value}%",
          fontSize: 18,
          fontWeight: "bold",
          color: activeColor,
          offsetCenter: [0, "10%"],
        },
        title: {
          fontSize: 12,
          color: "#64748b",
          offsetCenter: [0, "40%"],
        },
        data: [{ value: Math.round(value), name: label }],
      },
    ],
  };

  return (
    <ReactECharts
      option={option}
      style={{ width: "100%", height }}
      notMerge
    />
  );
}
